export default __webpack_public_path__ + "static/media/register_5.64b2b81b.jpg";